import {openDialog} from 'platform/components';

import {EmailCredentialsOwnerType, ListEmailCredentialsResponseBody} from '@dms/api/core';
import i18n from '@dms/i18n';

import {useOnMount, useQueryState} from 'shared/web';

import {EmailOAuthServiceForm} from '../components/EmailOAuthServiceForm';
import {EMAIL_CREDENTIALS_EDIT_QUERY_PARAM} from '../constants/emailCredentialsEditQueryParam';
import {isOAuthCredential} from '../utils/isOAuthCredential';

export const useOpenOAuthCredentials = (
  credentials: ListEmailCredentialsResponseBody | undefined,
  ownerType: EmailCredentialsOwnerType
) => {
  const [credentialsId, __, clearCredentialsId] = useQueryState(EMAIL_CREDENTIALS_EDIT_QUERY_PARAM);
  const createdCredentials = credentials?.credentials.find(
    (credential) => credential.id === credentialsId
  );

  useOnMount(() => {
    if (!createdCredentials) {
      return;
    }

    const isOAuth = isOAuthCredential(createdCredentials);

    if (!isOAuth) {
      return;
    }

    openDialog(
      <EmailOAuthServiceForm
        defaultValues={{
          title: createdCredentials.title,
          emailAddress: createdCredentials.emailAddress,
        }}
        providerCode={createdCredentials.provider}
        credentialsId={createdCredentials.id}
        ownerType={ownerType}
      />,
      {
        title: `${i18n.t('entity.emailService.labels.editOAuthTitle')} ${createdCredentials.title}`,
        id: createdCredentials.id,
        onCloseComplete: clearCredentialsId,
      }
    );
  });
};
